import * as React from 'react';
import {useState} from 'react';

import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {withRouter} from 'react-router';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';

import {GlobalCss} from 'components/global-css.js';
import {DatePickerWrapper} from 'components/DatePickerWrapper.js';
import {DateUtil} from 'utils/date-util.js';
import {ErrorMessage} from 'components/ErrorMessage.js';

const styles = {
  flexContainer: GlobalCss.flexContainer,
  leftJustifiedIitem: GlobalCss.leftJustifiedIitem,
  rightJustifiedIitem: GlobalCss.rightJustifiedIitem,
};

const EartagAnalyzerAllFarmsIndex = (props) => {
  const [notes, setNotes] = useState('');
  const [targetDate, setTargetDate] = useState(null);
  const [targetHour, setTargetHour] = useState('');
  const [targetMinute, setTargetMinute] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const createParams = () => {
    return {
      pathname: '/eartag_analyzer/all_farms/confirm',
      state: {
        targetDate: targetDate,
        targetHour: targetHour,
        targetMinute: targetMinute,
        notes: notes
      }
    };
  };

  const createAction = () => {
    const result = validate();
    if (!result.valid) {
      setErrorMessage(result.errors.join('\n'));
      return;
    } else {
      setErrorMessage('');
    }
    props.history.push(createParams());
  };

  const validate = () => {
    const errors = [];
    if (!targetDate) {
      errors.push('分析対象日時が選択されていません');
    }
    if (!targetHour) {
      errors.push('対象時間が選択されていません');
    }
    if (!targetMinute) {
      errors.push('対象分が選択されていません');
    }
    if (notes.length > 180) {
      errors.push('備考は180文字以内に設定してください。');
    }
    return {valid: errors.length === 0, errors: errors};
  };

  return (
    <div style={{marginLeft: '20px'}}>
      <h2>[イヤタグ] 全牧場一括再分析</h2>

      <div style={{marginLeft: 40, marginTop: 20}}>
        <ErrorMessage errorMessage={errorMessage} />
      </div>
      <ul className={props.classes.flexContainer} style={{marginLeft: 40, marginTop: 35, marginBottom: 20}}>
        <li style={{width: 150, marginRight: 16}}>
          <DatePickerWrapper
            label={'分析対象日'}
            date={targetDate}
            margin="none"
            syncState={(e) => setTargetDate(DateUtil.startOfDay(e))}
          />
        </li>
        <li style={{width: 110, marginRight: 10}}>
          <InputLabel htmlFor="cow-label" style={{fontSize: 12}}>対象時間</InputLabel>
          <Select
            style={{marginTop: 4, width: 100}}
            value={targetHour}
            onChange={(e) => setTargetHour(e.target.value)}
            inputProps={{name: 'inputPath', id: 'input-path'}}
          >
            {(() => {
              const list = [];
              for (let index = 0; index < 24; index++) {
                const hour = ('00' + index).slice(-2);
                list.push(<MenuItem key={`start-hour-${index}`} value={hour}>{hour} 時</MenuItem>);
              }
              return list;
            })()}
          </Select>
        </li>
        <li>
          <InputLabel htmlFor="cow-label" style={{fontSize: 12}}>分</InputLabel>
          <Select
            style={{marginTop: 4, width: 100}}
            value={targetMinute}
            onChange={(e) => setTargetMinute(e.target.value)}
            inputProps={{name: 'inputPath', id: 'input-path'}}
          >
            {(() => {
              const list = [];
              ['00', '10', '20', '30', '40', '50'].forEach((minute) => {
                list.push(<MenuItem key={`start-hour-${minute}`} value={minute}>{minute} 分</MenuItem>);
              });
              return list;
            })()}
          </Select>
        </li>
      </ul>
      <ul className={props.classes.flexContainer} style={{margin: '30px 40px 20px 40px'}}>
        <li>
          <TextField
            type="text"
            label="備考"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            variant="outlined"
            margin="dense"
            fullWidth={true}
            className={props.classes.textAreaField}
            multiline
            rows={5}
            style={{width: 500}}
          />
        </li>
      </ul>
      <ul className={props.classes.flexContainer}>
        <li style={{marginLeft: 38, marginTop: 20}}>
          <Button variant="contained" color="primary" onClick={() => createAction()}>
            実行
          </Button>
        </li>
      </ul>
    </div>
  );
};

EartagAnalyzerAllFarmsIndex.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const forExport = withRouter(withStyles(styles)(EartagAnalyzerAllFarmsIndex));
export {forExport as EartagAnalyzerAllFarmsIndex};
